export interface CheckoutAddress {
	zipCode: string;
	street: string;
	number: string;
	complement: string;
	district: string;
	city: string;
	state: string;
}

export interface CheckoutPersonalData {
	name: string;
	surName: string;
	document: string;
	phoneNumber: string;
	address: CheckoutAddress;
}

export const DEFAULT_PERSONAL_DATA: CheckoutPersonalData = {
	name: '',
	surName: '',
	document: '',
	phoneNumber: '',
	address: {
		zipCode: '',
		street: '',
		number: '',
		complement: '',
		district: '',
		city: '',
		state: '',
	},
};
